import axios from "axios";
import axiosRetry from "axios-retry";

const backendHost = process.env.NEXT_PUBLIC_BACKEND_HOST || "";
// the host may carry its own scheme (e.g. the dev box's https tailnet URL)
export const backendBaseURL = backendHost.includes("://")
  ? backendHost
  : process.env.NEXT_PUBLIC_ENV === "production" || process.env.NEXT_PUBLIC_ENV === "staging"
    ? `https://${backendHost}`
    : `http://${backendHost}`;

export const plumeAPI = axios.create({
  baseURL: backendBaseURL,
  timeout: 20000,
});

axiosRetry(plumeAPI, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) =>
    axiosRetry.isNetworkOrIdempotentRequestError(error) ||
    (error.response && error.response.status >= 500),
});

// WSS service REST API (for knowledge base endpoints)
const wssHost = process.env.NEXT_PUBLIC_WSS_SERVER || "";
// WSS_SERVER is a ws:// URL — convert to http(s) for REST
const wssRestBase = wssHost.replace("wss://", "https://").replace("ws://", "http://");

export const wssAPI = axios.create({
  baseURL: wssRestBase,
  timeout: 20000,
});

axiosRetry(wssAPI, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) =>
    axiosRetry.isNetworkOrIdempotentRequestError(error) ||
    (error.response && error.response.status >= 500),
});
